import NotificationModal from '@anm/components/modals/NotificationModal';
import * as semrush from '@anm/helpers/semrush';
import { FC } from 'react';

import { getInstructionsLink } from '../helpers';
import useShowError, { ERROR_NOTIFICATION_TIMEOUT } from '../hooks/useShowError';

type NotificationProps = {
  waveUrl: string;
  isInModal: boolean;
  onRedirect?: (link: string) => void;
};

const Notification: FC<NotificationProps> = ({ waveUrl, isInModal, onRedirect }) => {
  const [errorNetwork, closeNotification] = useShowError({ waveUrl, isInModal, onRedirect });

  if (!errorNetwork || !isInModal) return null;

  const isSemrush = semrush.isSemrushIframe();
  const learnMoreLink = `<a href="${getInstructionsLink({
    waveUrl,
    network: errorNetwork
  })}" target="_blank">Learn more</a>`

  const text = `This destination cannot be added. ${isSemrush ? '' : learnMoreLink}`;

  return (
    <NotificationModal
      key={errorNetwork}
      type="error"
      description={text}
      timeout={ERROR_NOTIFICATION_TIMEOUT}
      variant="aside"
      onModalClose={closeNotification}
    />
  );
};

export default Notification;
